var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "top-progress-bar-wrapper -helper--flex justify-center" },
    [
      _c("div", { staticClass: "content -helper--flex align-center fluid" }, [
        _c("span", { staticClass: "main-logo-dark-blue" }),
        _vm._v(" "),
        _c("div", { staticClass: "progress-bar-wrapper" }, [
          _c("span", {
            staticClass: "bar-fill",
            style: { width: _vm.progressBarWidth }
          })
        ]),
        _vm._v(" "),
        _vm.isBackShown
          ? _c("span", {
              staticClass: "top-bar-cta icon-back-btn",
              on: { click: _vm.handleBack }
            })
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4255294c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4255294c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/globalUiComponents/TopProgressController.vue
// module id = null
// module chunks = 